import {faMessageBot} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {nameForAnalytics} from '@rdcomponents/navigation/navigation-type';

import {appRoute} from '../../../../app-route';
import {AutoReplies} from '../../../../page/main/auto-replies/auto-replies';
import {AutoRepliesActivation} from '../../../../page/main/auto-replies/auto-replies-activation';
import {AutoReplyCreate} from '../../../../page/main/auto-reply-create/auto-reply-create';
import {AutoReplyEdit} from '../../../../page/main/auto-reply-edit/auto-reply-edit';
import {ResponseTemplates} from '../../../../page/main/response-templates/response-templates';
import {ResponseTemplatesCreateTemplate} from '../../../../page/main/response-templates-create-template/response-templates-create-template';
import {ResponseTemplatesEditGroup} from '../../../../page/main/response-templates-edit-group/response-templates-edit-group';
import {ResponseTemplatesEditTemplate} from '../../../../page/main/response-templates-edit-template/response-templates-edit-template';
import {useDomainConfig} from '../../../../provider/domain-config/domain-config-hook';
import {useLicenses} from '../../../../provider/license/license-hook';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {FeaturesEnum} from '../../../../service/user/user-type';
import {getMenuItemNameForAnalytics, isEnabledForDomainAndDoubleGis} from '../../../navigation/navigation-helper';
import {NavigationItemConfigType} from '../routing-type';

export function useReviewsAutoReplyNavigation(): Array<NavigationItemConfigType> {
    const {domainName} = useDomainConfig();
    const {licenses, availableFeatures, enabledFeatures} = useLicenses();
    const {getLocalizedString} = useLocale();

    return [
        {
            isAvailable:
                (availableFeatures[FeaturesEnum.reviewSuggests] &&
                    enabledFeatures.includes(FeaturesEnum.reviewSuggests)) ||
                (availableFeatures[FeaturesEnum.gptAutoReplyLicence] &&
                    enabledFeatures.includes(FeaturesEnum.gptAutoReplyLicence)),
            path: appRoute.autoRepliesRoot.path,
            icon: <FontAwesomeIcon icon={faMessageBot} />,
            label: getLocalizedString('CATEGORY_NAME__AUTO_REPLIES__ROOT'),
            [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__AUTO_REPLIES__ROOT'),
            redirectPath: appRoute.autoReplies.path,
            deniedPath: [appRoute.autoRepliesRoot.path],

            children: [
                {
                    isAvailable: isEnabledForDomainAndDoubleGis({
                        isDomainFeatureEnabled: availableFeatures[FeaturesEnum.reviewSuggests] || false,
                        isFeatureEnabled: Boolean(licenses[FeaturesEnum.reviewSuggests]?.isActive),
                        domainName,
                    }),
                    isActivated:
                        licenses[FeaturesEnum.reviewSuggests]?.isActive ||
                        licenses[FeaturesEnum.gptAutoReplyLicence]?.isActive,
                    path: appRoute.autoReplies.path,
                    label: getLocalizedString('CATEGORY_NAME__AUTO_REPLIES'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__AUTO_REPLIES'),
                    component:
                        licenses[FeaturesEnum.reviewSuggests]?.isActive ||
                        licenses[FeaturesEnum.gptAutoReplyLicence]?.isActive
                            ? AutoReplies
                            : AutoRepliesActivation,
                },
                {
                    path: appRoute.reviewsManagementResponseTemplates.path,
                    label: getLocalizedString('CATEGORY_NAME__RESPONSE_TEMPLATES'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__RESPONSE_TEMPLATES'),
                    component: ResponseTemplates,
                    exact: true,
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementAutoReplyCreate.path,
                    exact: true,
                    component: AutoReplyCreate,
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementResponseTemplatesCreateTemplate.path,
                    exact: true,
                    component: ResponseTemplatesCreateTemplate,
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementResponseTemplatesEditGroup.path,
                    exact: true,
                    component: ResponseTemplatesEditGroup,
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementResponseTemplatesEditTemplate.path,
                    exact: true,
                    component: ResponseTemplatesEditTemplate,
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementAutoReplyEdit.path,
                    exact: true,
                    component: AutoReplyEdit,
                },
            ],
        },
    ];
}
